var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center bg-custom-purple h-screen"},[_c('img',{staticClass:"mt-20 lg:w-32",staticStyle:{"width":"60%"},attrs:{"src":require("@/assets/images/survey/done-icon.png")}}),_c('div',{staticClass:"mt-20"},[_c('h1',{staticClass:"font-bold text-5xl"},[_vm._v("Thank you!")]),_c('br'),_c('h2',[_vm._v("Form submitted")])])])
}]

export { render, staticRenderFns }